import React, { Component } from "react";
import { MDBRow, MDBCol, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBModal, MDBModalHeader, MDBModalFooter, MDBModalBody } from "mdbreact";
import axios from "axios";
import ConfigData from "../Components/config";
import AppDataTable from "../Components/AppDataTable";

export default class AddDateJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ShowDateJob: { columns: [], rows: [] },
            arrayyears: [],
            modaladd: false,
            modaldelete: false,
            types: null,
            type_std: null,
            type_std_name: null,
            term: null,
            year: null,
            rob: null,
            robjob: null,
            daydate: null,
            monthdate: null,
            yeardate: null,
            oldtype_std: null,
            oldterm: null,
            oldyear: null,
            oldrob: null,
            oldstop_date: null,
        }
        this.handleAdd = this.handleAdd.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        axios.get(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/SelectDateRobJob").then((DateRobJob) => {
            if (DateRobJob.data.length !== 0) {
                let x = 0;
                while (x < DateRobJob.data.length) {
                    DateRobJob.data[x]["statusfill"] = <>
                        <button className="btn btn-warning btn-md" onClick={this.handleEdit} value={x}>แก้ไข</button>
                        <button className="btn btn-danger btn-md" onClick={this.handleDelete} value={x}>ลบ</button>
                    </>;
                    x++;
                }
                this.setState({
                    ShowDateJob: {
                        columns: [
                            { label: "ประเภทนักศึกษา", field: "type_std_name", },
                            { label: "รอบจบ", field: "robjob", },
                            { label: "วันที่สภาอนุมัติ", field: "stop_datename", },
                            { label: "จัดการ", field: "statusfill", },
                        ],
                        rows: DateRobJob.data
                    }
                })
            }
        })
        let arrayyear = [];
        let year = new Date().getFullYear()+544;
        let i = 0;
        while (i < 11) {
            arrayyear[i] = year.toString();
            year--;
            i++;
        }
        let options = arrayyear.map(d => ({
            "value": (d-543).toString(),
            "label": d,
        }))
        this.setState({ arrayyears: options });
    }

    handleAdd(event) {
        this.setState({ types: "add" });
        this.setState({ modaladd: true });
    }

    handleEdit(event) {
        this.setState({ types: "edit" });
        this.setState({ type_std: this.state.ShowDateJob.rows[event.target.value]["type_std"] });
        this.setState({ term: this.state.ShowDateJob.rows[event.target.value]["term"] });
        this.setState({ year: this.state.ShowDateJob.rows[event.target.value]["year"] });
        this.setState({ rob: this.state.ShowDateJob.rows[event.target.value]["rob"] });
        this.setState({ oldtype_std: this.state.ShowDateJob.rows[event.target.value]["type_std"] });
        this.setState({ oldterm: this.state.ShowDateJob.rows[event.target.value]["term"] });
        this.setState({ oldyear: this.state.ShowDateJob.rows[event.target.value]["year"] });
        this.setState({ oldrob: this.state.ShowDateJob.rows[event.target.value]["rob"] });
        this.setState({ oldstop_date: this.state.ShowDateJob.rows[event.target.value]["stop_date"] });
        let splitdate = this.state.ShowDateJob.rows[event.target.value]["stop_date"].split("-");
        this.setState({ daydate: splitdate[2] });
        this.setState({ monthdate: splitdate[1] });
        this.setState({ yeardate: splitdate[0] });
        this.setState({ modaladd: true });
    }

    toggle(event) {
        this.setState({ types: null });
        this.setState({ type_std: null });
        this.setState({ type_std_name: null });
        this.setState({ term: null });
        this.setState({ year: null });
        this.setState({ rob: null });
        this.setState({ robjob: null });
        this.setState({ daydate: null });
        this.setState({ monthdate: null });
        this.setState({ yeardate: null });
        this.setState({ oldtype_std: null });
        this.setState({ oldterm: null });
        this.setState({ oldyear: null });
        this.setState({ oldrob: null });
        this.setState({ oldstop_date: null });
        this.setState({ modaladd: false });
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault()
        let bodydata = {
            types: this.state.types,
            type_std: this.state.type_std,
            term: this.state.term,
            year: this.state.year,
            rob: this.state.rob,
            stop_date: this.state.yeardate + "-" + this.state.monthdate + "-" + this.state.daydate,

            oldtype_std: this.state.oldtype_std,
            oldterm: this.state.oldterm,
            oldyear: this.state.oldyear,
            oldrob: this.state.oldrob,
            oldstop_date: this.state.oldstop_date,
        }
        axios.post(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/InsertDateRobJob", bodydata).then((res) => {
            if (res.data === 1) {
                axios.get(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/SelectDateRobJob").then((DateRobJob) => {
                    if (DateRobJob.data.length !== 0) {
                        let x = 0;
                        while (x < DateRobJob.data.length) {
                            DateRobJob.data[x]["statusfill"] = <>
                                <button className="btn btn-warning btn-md" onClick={this.handleEdit} value={x}>แก้ไข</button>
                                <button className="btn btn-danger btn-md" onClick={this.handleDelete} value={x}>ลบ</button>
                            </>;
                            x++;
                        }
                        this.setState({
                            ShowDateJob: {
                                columns: [
                                    { label: "ประเภทนักศึกษา", field: "type_std_name", },
                                    { label: "รอบจบ", field: "robjob", },
                                    { label: "วันสุดท้าย", field: "stop_datename", },
                                    { label: "จัดการ", field: "statusfill", },
                                ],
                                rows: DateRobJob.data
                            }
                        })
                    }
                })
                this.setState({ types: null });
                this.setState({ type_std: null });
                this.setState({ term: null });
                this.setState({ year: null });
                this.setState({ rob: null });
                this.setState({ daydate: null });
                this.setState({ monthdate: null });
                this.setState({ yeardate: null });
                this.setState({ oldtype_std: null });
                this.setState({ oldterm: null });
                this.setState({ oldyear: null });
                this.setState({ oldrob: null });
                this.setState({ oldstop_date: null });
                this.setState({ modaladd: false });
            }
        })
    }

    handleDelete(event) {
        this.setState({ type_std: this.state.ShowDateJob.rows[event.target.value]["type_std"] });
        this.setState({ type_std_name: this.state.ShowDateJob.rows[event.target.value]["type_std_name"] });
        this.setState({ term: this.state.ShowDateJob.rows[event.target.value]["term"] });
        this.setState({ year: this.state.ShowDateJob.rows[event.target.value]["year"] });
        this.setState({ rob: this.state.ShowDateJob.rows[event.target.value]["rob"] });
        this.setState({ robjob: this.state.ShowDateJob.rows[event.target.value]["robjob"] });
        let splitdate = this.state.ShowDateJob.rows[event.target.value]["stop_date"].split("-");
        this.setState({ daydate: splitdate[2] });
        this.setState({ monthdate: splitdate[1] });
        this.setState({ yeardate: splitdate[0] });
        this.setState({ modaldelete: true });
    }

    handleConfirm(event) {
        event.preventDefault()
        let bodydata = {
            type_std: this.state.type_std,
            term: this.state.term,
            year: this.state.year,
            rob: this.state.rob,
            stop_date: this.state.yeardate + "-" + this.state.monthdate + "-" + this.state.daydate,
        }
        axios.post(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/DeleteDateRobJob", bodydata).then((res) => {
            if (res.data === 1) {
                axios.get(ConfigData.SERVER_URL + "FrontEnd_Tabian/petition/SelectDateRobJob").then((DateRobJob) => {
                    if (DateRobJob.data.length !== 0) {
                        let x = 0;
                        while (x < DateRobJob.data.length) {
                            DateRobJob.data[x]["statusfill"] = <>
                                <button className="btn btn-warning btn-md" onClick={this.handleEdit} value={x}>แก้ไข</button>
                                <button className="btn btn-danger btn-md" onClick={this.handleDelete} value={x}>ลบ</button>
                            </>;
                            x++;
                        }
                        this.setState({
                            ShowDateJob: {
                                columns: [
                                    { label: "ประเภทนักศึกษา", field: "type_std_name", },
                                    { label: "รอบจบ", field: "robjob", },
                                    { label: "วันที่สภาอนุมัติ", field: "stop_datename", },
                                    { label: "จัดการ", field: "statusfill", },
                                ],
                                rows: DateRobJob.data
                            }
                        })
                    }else{
                        this.setState({
                            ShowDateJob: { rows: DateRobJob.data }
                        })
                    }
                })
                this.setState({ type_std: null });
                this.setState({ type_std_name: null });
                this.setState({ term: null });
                this.setState({ year: null });
                this.setState({ rob: null });
                this.setState({ robjob: null });
                this.setState({ daydate: null });
                this.setState({ monthdate: null });
                this.setState({ yeardate: null });
                this.setState({ modaldelete: false });
            }
        })
    }

    render() {
        return (<>
            <span className="white-text mt-3" style={{ fontSize: "22px" }}>ข้อมูลรอบจบการศึกษา</span><span className="white-text mt-3" style={{ fontSize: "16px" }}> มหาวิทยาลัยราชภัฏกำแพงเพชร</span>

            <MDBRow>
                <MDBCol lg="12" md="12" sm="12">
                    <MDBCard className="mt-3">
                        <MDBCardBody>
                            <MDBCardTitle className="h5">
                                ข้อมูลรอบจบการศึกษา
                            </MDBCardTitle>
                            <MDBCardText>
                                {this.state.ShowDateJob.rows.length !== 0 ? <>
                                    <MDBRow>
                                        <MDBCol className="text-right"><button className="btn btn-primary btn-md" onClick={this.handleAdd}>เพิ่มข้อมูล</button></MDBCol>
                                    </MDBRow>
                                    <AppDataTable data={this.state.ShowDateJob} />
                                </> : <>
                                    <span className="text-danger">***ไม่มีข้อมูลรอบจบการศึกษา</span>&nbsp;&nbsp;&nbsp;
                                    <button className="btn btn-primary btn-md" onClick={this.handleAdd}>เพิ่มข้อมูล</button>
                                </>}
                            </MDBCardText>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>

            <MDBModal isOpen={this.state.modaladd} toggle={this.toggle} centered>
                <MDBModalHeader toggle={this.toggle}>ข้อมูลรอบจบการศึกษา</MDBModalHeader>
                <form onSubmit={this.handleSubmit}>
                    <MDBModalBody>
                        <div className="form-outline mt-2">
                            <label className="form-label" for="type_std">ประเภทนักศึกษา</label>
                            <select className="form-control" id="type_std" name="type_std" onChange={this.handleChange} required>
                                <option value="" hidden>ระบุประเภทนักศึกษา</option>
                                <option value="1" selected={this.state.type_std === "1" ? true : false}>ปกติ (กำแพงเพชร)</option>
                                <option value="2" selected={this.state.type_std === "2" ? true : false}>กศ.บป. (กำแพงเพชร)</option>
                                <option value="3" selected={this.state.type_std === "3" ? true : false}>กศ.บป. (แม่สอด)</option>
                                <option value="4" selected={this.state.type_std === "4" ? true : false}>ปริญญาโท,เอก</option>
                                <option value="5" selected={this.state.type_std === "5" ? true : false}>ปกติ (แม่สอด)</option>
                                <option value="6" selected={this.state.type_std === "6" ? true : false}>ป.วิชาชีพครู</option>
                            </select>
                        </div>
                        <MDBRow>
                            <MDBCol>
                                <div className="form-outline mt-2">
                                    <label className="form-label" for="term">ภาคเรียน</label>
                                    <select className="form-control" id="term" name="term" onChange={this.handleChange} required>
                                        <option value="" hidden>ระบุภาคเรียน</option>
                                        <option value="1" selected={this.state.term === "1" ? true : false}>1</option>
                                        <option value="2" selected={this.state.term === "2" ? true : false}>2</option>
                                        <option value="3" selected={this.state.term === "3" ? true : false}>3</option>
                                    </select>
                                </div>
                            </MDBCol>
                            <MDBCol>
                                <div className="form-outline mt-2">
                                    <label className="form-label" for="year">ปีการศึกษา</label>
                                    <select className="form-control" id="year" name="year" onChange={this.handleChange} required>
                                        <option value="" hidden>ระบุปีการศึกษา</option>
                                        {this.state.arrayyears.map((data) => {
                                            return <option value={data.label} selected={this.state.year === data.label ? true : false}>{data.label}</option>
                                        })}
                                    </select>
                                </div>
                            </MDBCol>
                            <MDBCol>
                                <div className="form-outline mt-2">
                                    <label className="form-label" for="rob">รอบ</label>
                                    <select className="form-control" id="rob" name="rob" onChange={this.handleChange} required>
                                        <option value="" hidden>ระบุรอบ</option>
                                        <option value="1" selected={this.state.rob === "1" ? true : false}>1</option>
                                        <option value="2" selected={this.state.rob === "2" ? true : false}>2</option>
                                        <option value="3" selected={this.state.rob === "3" ? true : false}>3</option>
                                        <option value="4" selected={this.state.rob === "4" ? true : false}>4</option>
                                        <option value="5" selected={this.state.rob === "5" ? true : false}>5</option>
                                        <option value="6" selected={this.state.rob === "6" ? true : false}>6</option>
                                    </select>
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <div className="form-outline mt-2">
                                    <label className="form-label" for="daydate">วันที่</label>
                                    <select className="form-control" id="daydate" name="daydate" onChange={this.handleChange} required>
                                        <option value="" hidden>ระบุวันที่</option>
                                        <option value="01" selected={this.state.daydate === "01" ? true : false}>1</option>
                                        <option value="02" selected={this.state.daydate === "02" ? true : false}>2</option>
                                        <option value="03" selected={this.state.daydate === "03" ? true : false}>3</option>
                                        <option value="04" selected={this.state.daydate === "04" ? true : false}>4</option>
                                        <option value="05" selected={this.state.daydate === "05" ? true : false}>5</option>
                                        <option value="06" selected={this.state.daydate === "06" ? true : false}>6</option>
                                        <option value="07" selected={this.state.daydate === "07" ? true : false}>7</option>
                                        <option value="08" selected={this.state.daydate === "08" ? true : false}>8</option>
                                        <option value="09" selected={this.state.daydate === "09" ? true : false}>9</option>
                                        <option value="10" selected={this.state.daydate === "10" ? true : false}>10</option>
                                        <option value="11" selected={this.state.daydate === "11" ? true : false}>11</option>
                                        <option value="12" selected={this.state.daydate === "12" ? true : false}>12</option>
                                        <option value="13" selected={this.state.daydate === "13" ? true : false}>13</option>
                                        <option value="14" selected={this.state.daydate === "14" ? true : false}>14</option>
                                        <option value="15" selected={this.state.daydate === "15" ? true : false}>15</option>
                                        <option value="16" selected={this.state.daydate === "16" ? true : false}>16</option>
                                        <option value="17" selected={this.state.daydate === "17" ? true : false}>17</option>
                                        <option value="18" selected={this.state.daydate === "18" ? true : false}>18</option>
                                        <option value="19" selected={this.state.daydate === "19" ? true : false}>19</option>
                                        <option value="20" selected={this.state.daydate === "20" ? true : false}>20</option>
                                        <option value="21" selected={this.state.daydate === "21" ? true : false}>21</option>
                                        <option value="22" selected={this.state.daydate === "22" ? true : false}>22</option>
                                        <option value="23" selected={this.state.daydate === "23" ? true : false}>23</option>
                                        <option value="24" selected={this.state.daydate === "24" ? true : false}>24</option>
                                        <option value="25" selected={this.state.daydate === "25" ? true : false}>25</option>
                                        <option value="26" selected={this.state.daydate === "26" ? true : false}>26</option>
                                        <option value="27" selected={this.state.daydate === "27" ? true : false}>27</option>
                                        <option value="28" selected={this.state.daydate === "28" ? true : false}>28</option>
                                        <option value="29" selected={this.state.daydate === "29" ? true : false}>29</option>
                                        <option value="30" selected={this.state.daydate === "30" ? true : false}>30</option>
                                        <option value="31" selected={this.state.daydate === "31" ? true : false}>31</option>
                                    </select>
                                </div>
                            </MDBCol>
                            <MDBCol>
                                <div className="form-outline mt-2">
                                    <label className="form-label" for="monthdate">เดือน</label>
                                    <select className="form-control" id="monthdate" name="monthdate" onChange={this.handleChange} required>
                                        <option value="" hidden>ระบุเดือน</option>
                                        <option value="01" selected={this.state.monthdate === "01" ? true : false}>ม.ค.</option>
                                        <option value="02" selected={this.state.monthdate === "02" ? true : false}>ก.พ.</option>
                                        <option value="03" selected={this.state.monthdate === "03" ? true : false}>มี.ค.</option>
                                        <option value="04" selected={this.state.monthdate === "04" ? true : false}>เม.ย.</option>
                                        <option value="05" selected={this.state.monthdate === "05" ? true : false}>พ.ค.</option>
                                        <option value="06" selected={this.state.monthdate === "06" ? true : false}>มิ.ย.</option>
                                        <option value="07" selected={this.state.monthdate === "07" ? true : false}>ก.ค.</option>
                                        <option value="08" selected={this.state.monthdate === "08" ? true : false}>ส.ค.</option>
                                        <option value="09" selected={this.state.monthdate === "09" ? true : false}>ก.ย.</option>
                                        <option value="10" selected={this.state.monthdate === "10" ? true : false}>ต.ค.</option>
                                        <option value="11" selected={this.state.monthdate === "11" ? true : false}>พ.ย.</option>
                                        <option value="12" selected={this.state.monthdate === "12" ? true : false}>ธ.ค.</option>
                                    </select>
                                </div>
                            </MDBCol>
                            <MDBCol>
                                <div className="form-outline mt-2">
                                    <label className="form-label" for="yeardate">ปี</label>
                                    <select className="form-control" id="yeardate" name="yeardate" onChange={this.handleChange} required>
                                        <option value="" hidden>ระบุปี</option>
                                        {this.state.arrayyears.map((data) => {
                                            return <option value={data.value} selected={this.state.yeardate === data.value ? true : false}>{data.label}</option>
                                        })}
                                    </select>
                                </div>
                            </MDBCol>
                           
                        </MDBRow> 
                    <MDBRow>
                      <MDBCol>
                        <div className="text-danger">
                           *วันที่สภาอนุมัติ
                        </div>
                      </MDBCol>
                        </MDBRow>
                    </MDBModalBody>
                    <MDBModalFooter>
                        {this.state.type_std === null || this.state.term === null || this.state.year === null || this.state.rob === null || this.state.daydate === null || this.state.monthdate === null || this.state.yeardate === null ? <>
                            <button type="submit" className="btn btn-primary btn-md" disabled>บันทึกข้อมูล</button>
                        </> : <>
                            <button type="submit" className="btn btn-primary btn-md">บันทึกข้อมูล</button>
                        </>}
                        <button type="button" className="btn btn-danger btn-md" onClick={this.toggle}>ยกเลิก</button>
                    </MDBModalFooter>
                </form>
            </MDBModal>

            <MDBModal isOpen={this.state.modaldelete} toggle={this.toggle} centered>
                <MDBModalHeader toggle={this.toggle}>ข้อมูลรอบจบการศึกษา</MDBModalHeader>
                <MDBModalBody>
                    ท่านต้องการลบข้อมูลรอบจบการศึกษา ภาค{this.state.type_std_name} รอบ {this.state.robjob}
                </MDBModalBody>
                <MDBModalFooter>
                    <button type="button" className="btn btn-primary btn-md" onClick={this.handleConfirm}>ยืนยัน</button>
                    <button type="button" className="btn btn-danger btn-md" onClick={this.toggle}>ยกเลิก</button>
                </MDBModalFooter>
            </MDBModal>

        </>);
    }
}